import { render, staticRenderFns } from "./mediaViewerDialog.vue?vue&type=template&id=9bfe499c&scoped=true"
import script from "./mediaViewerDialog.vue?vue&type=script&lang=js"
export * from "./mediaViewerDialog.vue?vue&type=script&lang=js"
import style0 from "./mediaViewerDialog.vue?vue&type=style&index=0&id=9bfe499c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfe499c",
  null
  
)

export default component.exports